export default __webpack_public_path__ + "static/media/PROCESS_STEP3.bd40b9e8.png";